import PRAPI from './PRAPI';

export default class ProofreadFile {

  static oriuq = '';
  static caches = {};
  static prevLoadTime = 0;

  static reloadTime = 15 * 1000;


  static createDefault() {
    return {
      photos: [],
      prevLoadTime: 0,
      previews: [],
      histories: [],
    };
  }

  static setOriuq(oriuq) {
    if (this.oriuq !== oriuq) {
      if (!this.caches.hasOwnProperty(oriuq)) {
        this.caches[oriuq] = this.createDefault();
      }
    }
    this.oriuq = oriuq;
  }

  static loadPhotos(forceUpdate) {
    if ( forceUpdate || Date.now() - this.caches[this.oriuq].prevLoadTime > this.reloadTime) {
      this.caches[this.oriuq].photos = [];
    }
    else {
      return new Promise((resolve, reject)=>{
        resolve(this.caches[this.oriuq].photos);
      });
    }

    return new Promise((resolve, reject)=>{
      PRAPI.loadPhotos(this.oriuq).then(photos => {
        this.caches[this.oriuq].photos = photos;
        this.caches[this.oriuq].prevLoadTime = Date.now();
        resolve(this.caches[this.oriuq].photos);

      }, reject)
    });
  }

  static getPhoto(name) {
    return new Promise((resolve, reject)=>{
      if (!this.caches.hasOwnProperty(this.oriuq) || !this.caches[this.oriuq].photos || (this.caches[this.oriuq].photos.length === 0 && this.caches[this.oriuq].prevLoadTime === 0)) {
        this.loadPhotos().then(()=>{
          let photo = this.caches[this.oriuq].photos.find(p=>{
            return p.name === name;
          });
          if (photo) resolve(photo);
          else reject();
        });
      }
      else {
        let photo = this.caches[this.oriuq].photos.find(p=>{
          return p.name === name;
        });
        if (photo) resolve(photo);
        else reject();
      }
    });
  }

  static uploadPhoto(file) {
    if (!this.caches.hasOwnProperty(this.oriuq)) {
      this.caches[this.oriuq] = this.createDefault();
    }

    return new Promise((resolve, reject)=>{
      PRAPI.uploadPhoto(this.oriuq, file)
      .then(photo=>{
        this.caches[this.oriuq].photos.push(photo);
        resolve(photo);
        /*
        if (Date.now() - this.caches[this.oriuq].prevLoadTime > this.reloadTime) {
          PRAPI.loadPhotos(this.oriuq).then(photos => {
            this.caches[this.oriuq].photos = photos;
            this.caches[this.oriuq].prevLoadTime = Date.now();
            resolve(this.caches[this.oriuq].photos);
          }, reject);
        }
        else {
          this.caches[this.oriuq].photos.push(photo);
          resolve(this.caches[this.oriuq].photos);
        }
        */
      }, reject)
    });
  }

  static deletePhotos(photoUniques) {
    return new Promise((resolve, reject)=>{
      PRAPI.deletePhotos(this.oriuq, photoUniques).then((deletedUniques)=>{

        this.caches[this.oriuq].photos = this.caches[this.oriuq].photos.filter(p=>{
          return deletedUniques.indexOf(p.name) < 0;
        });
        resolve(this.caches[this.oriuq].photos);
      }, reject);
    });
  }

  static load(uuid, koseiStart, doOpen) {
    return new Promise((resolve, reject)=>{
      PRAPI.getNewestDirection(uuid, this.oriuq, koseiStart, doOpen).then(
        ret=>{
          resolve({
            savedFabricData: ret.data,
            preview: null,
            previewFilename: null,
            openedStatus: ret.opened
          });
        },
        err=>{
          //console.log(err)
          ProofreadFile.loadPreview(uuid, koseiStart, doOpen).then(ret => {
            resolve({
              savedFabricData: null,
              preview: ret.blob,
              previewFilename: ret.filename,
              openedStatus: ret.error||'opened'
            });
          },
          err=>{
            reject(err);
            //console.log(err)
          })
        }
      );
    });
  }

  static loadOldDirection(filename) {
    return new Promise((resolve, reject)=>{
      PRAPI.getOldDirection(this.oriuq, filename).then(
        ret=>{
          resolve({
            savedFabricData: ret.data,
            preview: null,
            previewFilename: null,
            openedStatus: ret.opened
          });
        },
        err=>{
          reject(err);
        }
      );
    });
  }

  static loadPreview(uuid, koseiStart, doOpen) {
    let cache = this.caches[this.oriuq].previews.find(p=>{
      return p.koseiStart === koseiStart;
    });
    if (cache) {
      return Promise.resolve(cache);
    }
    return new Promise((resolve, reject)=>{
      PRAPI.getPreview(uuid, this.oriuq, koseiStart, doOpen).then(ret=>{
        this.caches[this.oriuq].previews.push({
          koseiStart: koseiStart,
          blob: ret.blob,
          filename: ret.filename
        });
        resolve(ret);
      },
      err=>{
        //console.log(err)
        reject(err);
      })
    })
  }


  static getPreview(filename) {
    let cache = this.caches[this.oriuq].previews.find(p=>{
      return p.filename === filename;
    });
    if (cache) {
      return Promise.resolve(cache.blob);
    }
    return new Promise((resolve, reject)=>{
      PRAPI.getPreviewWithFilename(this.oriuq, filename).then(blob=>{
        this.caches[this.oriuq].previews.push({
          koseiStart: null,
          blob: blob,
          filename: filename
        });
        resolve(blob);
      })
    });
  }

  static getDirectionPreview(filename) {
    let cache = this.caches[this.oriuq].previews.find(p=>{
      return p.filename === filename;
    });
    if (cache) {
      return Promise.resolve(cache.blob);
    }
    return new Promise((resolve, reject)=>{
      PRAPI.getDirectionPreviewWithFilename(this.oriuq, filename).then(blob=>{
        this.caches[this.oriuq].previews.push({
          koseiStart: null,
          blob: blob,
          filename: filename
        });
        resolve(blob);
      })
    });
  }

  static listHistories() {
    if (this.caches.hasOwnProperty(this.oriuq) && this.caches[this.oriuq].histories.length > 0) {
      return Promise.resolve(this.caches[this.oriuq].histories);
    }
    return new Promise((resolve, reject)=>{
      PRAPI.loadHistories(this.oriuq).then(histories => {
        this.caches[this.oriuq].histories = histories;
        resolve(histories);
      }, reject);
    });
  }
   
}